module.exports = __webpack_public_path__ + "static/Q2_2022_Announcement_Financial_Results-d5307126fce5f85cfdbdc6f0bb9aa382.pdf";